import { render, staticRenderFns } from "./loading-placeholder.vue?vue&type=template&id=23394145"
import script from "./loading-placeholder.vue?vue&type=script&lang=js"
export * from "./loading-placeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports